import PolizaScreen from "../../poliza/screens/PolizaScreen"

const HomeInScreen = () => {
    return (
        <>
            <PolizaScreen />
        </>
    )
}

export default HomeInScreen